module.exports = __webpack_public_path__ + "static/media/clothes-3.67dc97f9.jpg";